import { useMutation, useQueryClient } from "@tanstack/react-query";
import { removeAccountCollaborator } from "services/accounts";
import { useRootStore } from "store";
import queryKeys from "../../keys";

export interface useRemoveAccountCollaboratorInput {
  accountId: string;
  userId: string;
}

export const useRemoveAccountCollaborator = () => {
  const {
    authStore,
    uiStore: { setApiErrorToast },
  } = useRootStore();

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ accountId, userId }: useRemoveAccountCollaboratorInput) =>
      removeAccountCollaborator(authStore, accountId, userId),
    onError: (error) =>
      setApiErrorToast(error, "Unable to remove collaborator"),
    onSuccess: (_, { accountId }) => {
      queryClient.invalidateQueries(
        queryKeys.accounts.collaborators({ context: accountId }).queryKey
      );
    },
  });
};
